import React from 'react';
import {
    Table,
    Row,
    Spin,
    Button,
    Popconfirm,
} from 'antd';

import { asyncGet, actions, asyncGetUserList } from './reducers';
import { connect } from 'react-redux';
import SearchForm from './search.js';
import moment from 'moment';


class AgencyAnalysis extends React.Component {
    state = {
        selectedRowKeys: [],
    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        this.props.asyncGet();
        this.props.asyncGetUserList();
    }

    changeHandle = (pagination, filters, sorter) => {
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };
    /**
     * 分页器改变数据处理
     */
    handlePaginationChange = (current, pageSize) => {
        let pagination = {
            current,
            pageSize,
        };
        this.props.changePagination(pagination);
        this.props.asyncGet();
    };

    reStart = record => {
        const {clientId} = record;
        this.props.reStart({clientIds: [clientId], action: '7', executeNow: true});
        this.props.asyncGet();
    }

    edit = record => {
        this.props.editShow();
        this.props.changeCurrentSelectId(record.clientId);
    }

    renderAction = (text, record) => {
        // console.log(expanded, record);
        return (
            <div>
                <Button type="primary" style={{ marginRight: '5px' }} size="small" onClick={() => {
                    this.edit(record);
                }}>
                    编辑
                </Button>
                <Popconfirm
                    title='确认重启'
                    okText='确定'
                    cancelText='取消'
                    onConfirm={() => {
                        this.reStart(record);
                    }}>
                    <Button type="danger" style={{ marginRight: '5px' }} size="small">
                        重启
                    </Button>
                </Popconfirm>
            </div>
        );
    };

    onSelectChange = selectedRowKeys => {
        this.props.getTransferData({ selectedRowKeys });
    }

    render() {
        let { list, uiStatus } = this.props;
        let { isLoading } = uiStatus;
        const columns = [
            {
                title: '任务类型',
                dataIndex: 'taskSource',
                key: 'taskSource',
            },
            {
                title: '名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '总量控制',
                dataIndex: 'tc',
                key: 'tc',
            },
            {
                title: '类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: 'est',
                dataIndex: 'est',
                key: 'est',
            },
            {
                title: 'act',
                dataIndex: 'act',
                key: 'act',
            },
            {
                title: 'est2',
                dataIndex: 'est2',
                key: 'est2',
            },
            {
                title: 'act2',
                dataIndex: 'act2',
                key: 'act2',
            },
            {
                title: '期望率',
                dataIndex: 'hopeRate',
                key: 'hopeRate',
            },
            {
                title: '完成率',
                dataIndex: 'finishedRate',
                key: 'finishedRate',
            },
        ];

        return (
            <div style={{ marginBottom: '20px' }}>
                <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                    <SearchForm {...this.props} />
                </Row>

                <Spin spinning={isLoading} tip="加载中...">
                    <Table
                        columns={columns}
                        dataSource={list}
                        pagination={false}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    list: state.taskInfo.list,
    uiStatus: state.taskInfo.uiStatus,
});
const mapDispatchToProps = dispatch => ({
    asyncGet: () => dispatch(asyncGet()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
    changeCurrentSelectId: id => dispatch(actions.changeCurrentSelectId(id)),
    asyncGetUserList: () => dispatch(asyncGetUserList()),
});
export default connect(mapStateToProps, mapDispatchToProps)(AgencyAnalysis);






// WEBPACK FOOTER //
// ./pages/sign/taskInfo/index.js